<script>
export let className = ""
</script>

<div class="{className}"></div>
